import { ReactNode } from 'react';

import { TrialListItemWithIcon } from './TrialListItemWithIcon';

import { Stack } from '@cast/design-system';

type FeatureItem = {
  icon: ReactNode;
  text: string;
};

type Props = {
  items: FeatureItem[];
};

export const FeatureList = ({ items }: Props) => {
  return (
    <Stack component="ul" gap={8} sx={{ m: 0, p: 0, listStyle: 'none' }}>
      {items.map((item) => (
        <TrialListItemWithIcon
          key={item.text}
          icon={item.icon}
          text={item.text}
        />
      ))}
    </Stack>
  );
};
